import { z } from "zod";

const ErrorsResponseSchema = z.object({
    property_type: z.array(z.string()),
    name: z.array(z.string()),
    preferred_currency: z.array(z.string()),
    time_zone: z.array(z.string()),
    primary_email: z.array(z.string()),
    primary_phone_country_code: z.array(z.string()),
    primary_phone: z.array(z.string()),
    postal_code: z.array(z.string()),
    country: z.array(z.string()),
    state: z.array(z.string()),
    city: z.array(z.string()),
    street_address: z.array(z.string()),
    longitude: z.array(z.string()),
    latitude: z.array(z.string()),
    description: z.array(z.string()),
    website: z.array(z.string()),
    cc_emails: z.array(z.string()),
    accounting_email: z.array(z.string()),
    mobile_number_country_code: z.array(z.string()),
    mobile_number: z.array(z.string()),
    enable_cvv: z.array(z.string()),
});

export const ValidationErrorResponse = z.object({
    code: z.number(),
    message: z.string(),
    errors: ErrorsResponseSchema,
    success: z.boolean(),
});

export type ValidationErrorResponse = z.infer<typeof ValidationErrorResponse>;